import { css } from '@emotion/core'

// Shared layout for the "no items" message, used by both `NoItemsMessage` and its skeleton
// (`NoItemsMessageSkeleton`) so the icon/text spacing stays in sync.
export const noItemsMessageCss = css`
  display: flex;
  align-items: center;
  margin-top: 8px;
  margin-inline-start: 8px;
  gap: 24px;
  padding-bottom: 16px;

  &[is-dense] {
    gap: 12px;
    margin-inline-start: 0;
  }

  & > p {
    padding: 0;
  }
`
